import React from 'react';
import { useNotification } from '../contexts/NotificationContext';
import Notification from './Notification';

const NotificationContainer: React.FC = () => {
  const { notifications, hideNotification } = useNotification();

  return (
    <div className="fixed top-4 right-4 z-[10000] space-y-2">
      {notifications.map((notification) => (
        <div key={notification.id}>
          <Notification
            message={notification.message}
            type={notification.type}
            isVisible={true}
            onClose={() => hideNotification(notification.id)}
            duration={notification.duration}
          />
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;
